<!-- 导出弹窗 -->
<template>
  <div>
    <ku-dialog :title="$t('导出设置')" :visible.sync="visibleSync" @opened="openExport" @close="closeExport" @cancel="closeExport" @confirm="exportConfirm">
      <div class="top-box d-flex align-center pl-1">
        {{ $t('已勾选') }}
        <span>{{ selectedData.length }}</span>
        {{ $t('条') }},{{ $t('总筛选结果') }}
        <span>{{ totalNum }}</span>
        {{ $t('条') }}
      </div>
      <div class="center-box mt-1-5">
        <div class="center-title mb-1">
          {{ $t('导出方式') }}
        </div>
        <el-radio-group v-model="exportStyle">
          <el-radio :label="1" :disabled="totalNum > 6000">
            {{ $t('导出全部筛选结果') }}
            <el-tooltip placement="bottom" popper-class="tooltip-icon">
              <div slot="content">{{ $t('导出筛选结果后的全部记录，最多不超过6000条') }}</div>
              <i class="iconfont icon-a-Frame1916"></i>
            </el-tooltip>
          </el-radio>
          <el-radio :label="2">
            {{ $t('导出筛选结果前') }}
            <el-input v-model="exportNum" maxlength="5" class="input_export" type="text" :placeholder="$t('1-6000')" :min="1" @input="changeInput" />
            {{ $t('条') }}
            <el-tooltip placement="bottom" popper-class="tooltip-icon">
              <div slot="content">{{ $t('导出筛选结果后的前***条，最多不超过6000条') }}</div>
              <i class="iconfont icon-a-Frame1916"></i>
            </el-tooltip>
          </el-radio>
          <el-radio :label="3" :disabled="selectedData.length === 0">
            {{ $t('导出勾选结果') }}
            <el-tooltip placement="bottom" popper-class="tooltip-icon">
              <div slot="content">{{ $t('导出在列表中勾选的记录') }}</div>
              <i class="iconfont icon-a-Frame1916"></i>
            </el-tooltip>
          </el-radio>
        </el-radio-group>
      </div>
      <div class="bottom-box">
        <div class="bottom-title d-flex align-center justify-between">
          <span class="font-weight-600">{{ $t('字段设置') }}</span>
          <div class="d-flex align-center">
            <el-popover ref="popover" placement="bottom" trigger="click" popper-class="popper-export-view">
              <div class="view-list">
                <div class="view-title d-flex align-center justify-between">
                  <span>{{ $t('模板展示') }}</span>
                  <div class="d-flex align-center pointer" @click="addItemView">
                    <span class="iconfont icon-tianjiarenwu1 d-inline-block" style="color: #3a71ff; font-size: 13px; margin-right: 5px; margin-top: 2px"></span>
                    <span>{{ $t('新建模板') }}</span>
                  </div>
                </div>
                <div class="view-content">
                  <div
                    v-for="(itemView, indexView) in viewList"
                    :key="indexView"
                    class="view-item d-flex justify-between align-center pointer"
                    :style="checkedId === itemView.id ? 'background-color:#3A71FF;' : ''"
                    @click="clickItemView(itemView)"
                  >
                    <div class="d-flex align-center">
                      <span v-if="checkedId === itemView.id" class="iconfont icon-chenggong d-inline-block" style="color: #fff; margin-right: 5px"></span>
                      <span :style="checkedId === itemView.id ? 'color:#fff;' : 'color:#1D2129;'">{{ itemView.viewName }}</span>
                    </div>
                    <div class="d-flex align-center" :style="checkedId === itemView.id ? 'color:#fff;' : 'color: #86909C;'">
                      <i class="iconsimple icon-s-bianji pointer" style="margin-right: 12px" @click="editItemView(itemView)"></i>
                      <i class="iconsimple icon-s-shanchurenwu pointer" @click="delItemView(itemView)"></i>
                    </div>
                  </div>
                  <el-empty v-show="!viewList.length" :image="require('@klinx/ems/src/assets/statistics-empty-bright.png')" :description="$t('暂无数据')" :image-size="70" />
                </div>
              </div>
              <el-button slot="reference" style="width: 155px; height: 32px !important; line-height: 10px !important; font-size: 14px">
                <div class="d-flex align-center justify-between">
                  <span class="d-flex align-center">
                    <span class="iconfont icon-biaoge" style="font-size: 13.5px; margin-right: 5px; margin-top: 0.5px"></span>
                    <span v-if="checkedName.length <= 6">{{ checkedName }}</span>
                    <span v-else>{{ checkedName.slice(0, 6) + '...' }}</span>
                  </span>
                  <span class="iconsimple icon-s-xiajiantou"></span>
                </div>
              </el-button>
            </el-popover>
            <div class="d-flex bottom-handle">
              <div class="d-flex align-center justify-center" @click="saveView">
                <el-tooltip placement="bottom" popper-class="tooltip-icon">
                  <div slot="content">{{ $t('保存模板') }}</div>
                  <i class="iconsimple icon-s-baocun"></i>
                </el-tooltip>
              </div>
              <div class="d-flex align-center justify-center" @click="updateField">
                <el-tooltip placement="bottom" popper-class="tooltip-icon">
                  <div slot="content">{{ $t('与列显隐同步') }}</div>
                  <i class="iconsimple icon-s-yunhang" style="font-size: 18px"></i>
                </el-tooltip>
              </div>
            </div>
          </div>
        </div>
        <div class="bottom-content d-flex align-center justify-between">
          <div v-if="showCheckBox" class="bottom-content-left">
            <div class="top-title d-flex align-center pl-1-5 pr-1-5 justify-between">
              <el-checkbox v-model="isAllChecked" :indeterminate="isIndeterminate" @change="handleTreeCheckedAll">
                {{ $t('全选') }}
              </el-checkbox>
              <span>{{ selectedFieldData.length + '/' + allFieldData.length }}{{ $t('项') }}</span>
            </div>
            <div class="center-tree">
              <div class="p-1">
                <el-input v-model="filterText" :placeholder="$t('请输入')" clearable @keyup.enter.native="searchSizer">
                  <template slot="append">
                    <i class="iconfont icon-sousuo1" @click="searchSizer"></i>
                  </template>
                </el-input>
              </div>
              <div class="pl-1-5 pb-1">
                <el-tree
                  ref="treeRef"
                  :data="allFieldData"
                  show-checkbox
                  node-key="value"
                  :expand-on-click-node="false"
                  :default-expand-all="true"
                  :check-on-click-node="true"
                  :props="defaultProps"
                  :filter-node-method="filterNode"
                  @check="handleTreeDataCheck"
                />
              </div>
            </div>
          </div>
          <div class="bottom-content-right ml-1">
            <div class="bottom-content-right-header">
              <div>
                <span>{{ $t('已选') }}</span>
                <span class="text">{{ $t('拖动可排序') }}</span>
              </div>
              <div class="d-flex align-center">
                <span class="count">{{ selectedFieldData.length }}{{ $t('项') }}</span>
                <el-button :disabled="!selectedFieldData.length" type="primary" style="margin-right: 0; height: 26px !important; line-height: 7.5px; margin-left: 12px !important" @click="delSelectedField('all')">
                  {{ $t('清除') }}
                </el-button>
              </div>
            </div>
            <vxe-grid
              ref="xTable"
              :height="352"
              :scroll-y="{ enabled: false }"
              class="sortable-row"
              keep-source
              highlight-hover-row
              :data="selectedFieldData"
              :columns="fieldTableColumn"
              row-id="name"
              border
              row-key
              cell-class-name="c-class-style"
              header-row-class-name="h-class-style"
              :edit-config="{
                trigger: 'click',
                mode: 'cell',
                autofocus: '.vxe-input--inner',
                beforeEditMethod({ columnIndex }) {
                  if (columnIndex !== 3) {
                    return false;
                  }
                  return true;
                }
              }"
            >
              <!-- 拖动 -->
              <template v-slot:sortTabel>
                <span class="drag-btn"><i class="iconsimple icon-s-tuodong1"></i></span>
              </template>
              <template v-slot:operation="{ rowIndex }">
                <el-button type="text" @click="delSelectedField('single', rowIndex)">{{ $t('删除') }}</el-button>
              </template>
              <!-- 列宽编辑 -->
              <template #width_edit="{ row }">
                <el-input v-model="row.width" :placeholder="$t('请输入')" />
              </template>
              <template #empty>
                <el-empty :image="require('@/assets/404_images/no-data-small.png')" :description="$t('暂无数据')" />
              </template>
            </vxe-grid>
          </div>
        </div>
      </div>
    </ku-dialog>
    <!-- 新增弹窗 -->
    <ku-dialog :title="viewDialogType === 0 ? $t('新增模板') : $t('编辑模板')" :visible.sync="isShowAddView" width="550px" @close="addViewClose" @cancel="addViewClose" @confirm="addViewSure">
      <el-form ref="addViewForm" :model="addViewForm" :rules="addViewFormRules">
        <el-form-item :label="$t('模板名称')" prop="name"><el-input v-model="addViewForm.name" maxlength="20" :placeholder="$t('请输入')" @keyup.enter.native="addViewSure" /></el-form-item>
      </el-form>
    </ku-dialog>
  </div>
</template>

<script>
import Sortable from 'sortablejs';
export default {
  name: 'ExportPopUpNew',
  props: {
    allFieldData: {
      // 导出字段
      type: Array,
      default() {
        [];
      }
    },
    showFieldData: {
      // 导出字段（列显隐）
      type: Array,
      default() {
        [];
      }
    },
    selectedData: {
      // 勾选的列表项
      type: Array,
      default() {
        [];
      }
    },
    totalNum: {
      // 所筛总数
      type: Number,
      default: 0
    },
    visible: {
      type: Boolean,
      default: false
    },
    showCheckBox: {
      type: Boolean,
      default: true
    },
    loading: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      exportStyle: 1, // 导出类型
      exportNum: '', // 导出数
      isIndeterminate: false, // 全选标识
      isAllChecked: false, // 全选未勾选
      defaultProps: {
        children: 'children',
        label: 'name'
      },
      filterText: '', // 关键字筛选
      visibleSync: false,
      selectedFieldData: [], // 已经勾选字段
      fieldTableColumn: [
        {
          field: 'sortTabel',
          align: 'center',
          width: 40,
          slots: {
            default: 'sortTabel'
          }
        },
        {
          width: 40,
          title: '序',
          align: 'center',
          type: 'seq'
        },
        {
          field: 'name',
          title: this.$t('字段'),
          minWidth: 120
        },
        {
          field: 'width',
          title: this.$t('Excel列宽'),
          editRender: { autofocus: '.el-input__inner' },
          minWidth: 120,
          slots: { edit: 'width_edit' }
        },
        {
          field: 'operation',
          title: this.$t('操作'),
          width: 55,
          fixed: 'right',
          slots: {
            default: 'operation'
          }
        }
      ],
      sortable: '',
      // 模板相关
      viewList: [], // 模板列表
      checkedId: 1,
      checkedName: this.$t('前端测试默认模板'),
      sureLoading: false,
      isShowAddView: false,
      viewDialogType: 0,
      addViewForm: { name: '' },
      addViewFormRules: {
        name: [
          {
            required: true,
            message: this.$t('请输入'),
            trigger: 'blur'
          }
        ]
      }
    };
  },
  watch: {
    visible() {
      this.visibleSync = this.visible;
    },
    filterText(val) {
      if (!val) {
        this.$refs.treeRef.filter(val);
      }
    }
  },
  beforeDestroy() {
    if (this.sortable) {
      this.sortable.destroy();
    }
  },
  methods: {
    // 表格拖动排序
    rowDrop() {
      this.$nextTick(() => {
        const xTable = this.$refs.xTable;
        this.sortable = Sortable.create(xTable.$el.querySelector('.body--wrapper>.vxe-table--body tbody'), {
          handle: '.drag-btn',
          onEnd: ({ newIndex, oldIndex }) => {
            const currRow = this.selectedFieldData.splice(oldIndex, 1)[0];
            this.selectedFieldData.splice(newIndex, 0, currRow);
          }
        });
      });
    },
    // 删除字段
    delSelectedField(type, index) {
      if (type === 'all') {
        this.$confirm(this.$t('是否确认清除全部已选字段？'), this.$t('提示'), {
          confirmButtonText: this.$t('确 定'),
          cancelButtonText: this.$t('取 消'),
          type: 'warning'
        }).then(() => {
          this.selectedFieldData = [];
          this.$refs.treeRef.setCheckedNodes([]);
          this.isIndeterminate = false;
          this.isAllChecked = false;
        });
      } else {
        this.selectedFieldData.splice(index, 1);
        this.$refs.treeRef.setCheckedNodes(this.selectedFieldData);
        if (this.selectedFieldData.length === this.allFieldData.length) {
          this.isIndeterminate = false;
          this.isAllChecked = true;
        } else {
          this.isIndeterminate = true;
        }
        if (this.selectedFieldData.length === 0) {
          this.isAllChecked = false;
          this.isIndeterminate = false;
        }
      }
    },
    searchSizer() {
      this.$refs.treeRef.filter(this.filterText);
    },
    filterNode(value, data) {
      if (!value) return true;
      return data.name.indexOf(value) !== -1;
    },
    // 保存模板
    saveView() {},
    // 更新字段
    updateField() {
      this.$confirm(this.$t('是否确认与列显隐字段同步？'), this.$t('提示'), {
        confirmButtonText: this.$t('确 定'),
        cancelButtonText: this.$t('取 消'),
        type: 'warning'
      }).then(() => {
        this.selectedFieldData = JSON.parse(JSON.stringify(this.showFieldData));
        this.$refs.treeRef.setCheckedNodes(this.selectedFieldData);
        if (this.selectedFieldData.length === this.allFieldData.length) {
          this.isIndeterminate = false;
          this.isAllChecked = true;
        } else {
          this.isIndeterminate = true;
        }
        if (this.selectedFieldData.length === 0) {
          this.isAllChecked = false;
          this.isIndeterminate = false;
        }
      });
    },
    // 新增/编辑确定
    addViewSure() {
      this.$refs.addViewForm.validate((valid) => {
        if (valid) {
          this.sureLoading = true;
          if (this.viewDialogType === 0) {
            // emsStatisticsApi
            //   .viewPageAdd({ viewConf: JSON.stringify(this.viewData), viewName: this.addViewForm.name })
            //   .then((response) => {
            //     const res = response.data;
            //     if (res.isSuccess) {
            //       this.$message.success(this.$t('新增成功') + '！');
            //       this.getViewPage();
            //       this.isShowDialog = false;
            //     } else {
            //       this.$message.info(res.msg);
            //     }
            //   })
            //   .finally(() => {
            //     this.sureLoading = false;
            //   });
          } else {
            // 编辑
          }
        } else {
          return false;
        }
      });
    },
    // 新增取消
    addViewClose() {
      this.isShowAddView = false;
      this.$refs.addViewForm.resetFields();
    },
    // 新增模板
    addItemView() {
      this.viewDialogType = 0;
      this.addViewForm.name = '';
      this.isShowAddView = true;
      this.$refs['popover'].doClose();
    },
    // 编辑模板
    editItemView(val) {
      this.viewDialogType = 1;
      this.addViewForm.name = val.viewName;
      this.isShowAddView = true;
      this.viewData = JSON.parse(val.viewConf);
      this.$refs['popover'].doClose();
    },
    // 删除模板
    delItemView(val) {
      if (this.viewList.length === 1) {
        this.$message.info(this.$t('最低保留一个模板') + '！');
        return false;
      }
      this.$refs['popover'].doClose();
      this.viewData = JSON.parse(val.viewConf);
      this.$confirm(this.$t('是否确认删除该模板？'), this.$t('提示'), {
        confirmButtonText: this.$t('确 定'),
        cancelButtonText: this.$t('取 消'),
        type: 'warning'
      }).then(() => {
        // emsStatisticsApi.viewPageDel({ 'ids[]': this.checkedId }).then((response) => {
        //   const res = response.data;
        //   if (res.isSuccess) {
        //     this.$message.success(this.$t('删除成功') + '！');
        //     this.getViewPage();
        //     this.isShowAddView = false;
        //   } else {
        //     this.$message.info(res.msg);
        //   }
        // });
      });
    },
    exportConfirm() {
      // 确认导出
      if (this.exportStyle === 3 && this.selectedData.length === 0) {
        this.$message.warning(this.$t('请在列表勾选需要导出的数据') + '！');
        return false;
      }
      if (this.exportStyle === 2 && !this.exportNum) {
        this.$message.warning(this.$t('请输入需要导出的数据数量') + '！');
        return false;
      }
      if (this.selectedFieldData.length === 0) {
        this.$message.warning(this.$t('请选择要导出的字段') + '！');
        return false;
      }
      for (let i = 0; i < this.selectedFieldData.length; i++) {
        this.$message.warning(this.$t('导出字段Excel列宽不可为空') + '！');
        if (!this.selectedFieldData[i].width) {
          return false;
        }
      }
      var objData = {
        title: this.selectedFieldData || [],
        exportStyle: this.exportStyle,
        exportNum: this.exportNum
      };
      this.$emit('getData', objData); // 接收数据
    },
    closeExport() {
      // 关闭
      this.$emit('close', false);
    },
    openExport() {
      // 打开导出弹窗
      this.$nextTick(() => {
        this.$refs.treeRef?.setCheckedNodes(this.showFieldData);
        this.selectedFieldData = JSON.parse(JSON.stringify(this.showFieldData));
        if (this.selectedFieldData.length === this.allFieldData.length) {
          this.isIndeterminate = false;
          this.isAllChecked = true;
        } else {
          this.isIndeterminate = true;
        }
        if (this.selectedFieldData.length === 0) {
          this.isAllChecked = false;
          this.isIndeterminate = false;
        }
        this.rowDrop();
        this.$emit('open');
      });
    },
    handleTreeCheckedAll() {
      // 导出全选
      if (this.isAllChecked) {
        // 全选
        this.$refs.treeRef.setCheckedNodes(this.allFieldData);
      } else {
        // 取消选中
        this.$refs.treeRef.setCheckedKeys([]);
      }
      this.isIndeterminate = false;
      this.selectedFieldData = this.$refs.treeRef?.getCheckedNodes() || [];
    },
    handleTreeDataCheck(item, { checkedKeys }) {
      // 导出字段勾选
      if (checkedKeys.includes(item.value)) {
        this.selectedFieldData.push(item);
      } else {
        this.selectedFieldData = this.selectedFieldData.filter((v) => v.value !== item.value);
      }
      if (this.selectedFieldData.length === this.allFieldData.length) {
        this.isIndeterminate = false;
        this.isAllChecked = true;
      } else {
        this.isIndeterminate = true;
      }
      if (this.selectedFieldData.length === 0) {
        this.isAllChecked = false;
        this.isIndeterminate = false;
      }
    },
    changeInput() {
      var pattern = /^[1-9][0-9]*$/; // 正整数的正则表达式
      // 不符合正整数时
      if (this.exportNum && !pattern.test(this.exportNum)) {
        this.$message.warning(this.$t('导出条数只能为正整数') + '！');
        this.exportNum = null;
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.top-box {
  height: 38px;
  width: 630px;
  background: #f7f8fa;
  font-family: PingFang SC;
  font-size: 14px;
  color: #1d2129;
  span {
    display: inline-block;
    color: #3a71ff;
    margin: 0 5px;
  }
}
.center-box {
  .center-title {
    font-family: PingFang SC;
    font-size: 14px;
    font-weight: 600;
    color: #1d2129;
  }
  ::v-deep {
    .el-radio {
      margin-right: 26px;
      margin-bottom: 16px;
    }
    .el-radio__label {
      font-family: PingFang SC;
      font-size: 14px;
      color: #1d2129;
      padding-left: 6px;
    }
    .el-radio__input.is-checked + .el-radio__label {
      color: #1d2129;
    }
  }
  .input_export {
    width: 88px !important;
    margin: 0 5px;
  }
  i {
    color: #86909c;
    font-size: 13px;
    display: inline-block;
    margin-left: 5px;
  }
}
.bottom-box {
  .bottom-title {
    font-family: PingFang SC;
    font-size: 14px;
    color: #1d2129;
    .bottom-handle {
      margin-left: 6px;
      cursor: pointer;
      div {
        border-radius: 2px 0px 0px 2px;
        width: 34px;
        height: 32px;
        border: 1px solid #e5e6eb;
        &:first-child {
          border-right: none;
        }
      }
    }
  }
  .bottom-content {
    margin-top: 6px;
    .bottom-content-left {
      width: 250px;
      border: 1px solid #e5e6eb;
      // 修改默认滚动条样式
      ::-webkit-scrollbar {
        width: 4px;
      }
      ::-webkit-scrollbar-thumb {
        background-color: rgba(15, 31, 46, 0.1);
        border-radius: 6px;
      }
      ::-webkit-scrollbar-thumb:hover {
        background-color: rgba(15, 31, 46, 0.1);
      }
      .top-title {
        cursor: pointer;
        border-bottom: 1px solid #eee;
        font-family: PingFang SC;
        font-size: 12px;
        color: #4e5969;
        background: #f7f8fa;
        height: 40px;
        ::v-deep {
          .el-checkbox__label {
            font-family: PingFang SC;
            font-size: 14px;
            font-weight: 600;
            padding-left: 8px;
          }
        }
      }
      .center-tree {
        height: 350px;
        overflow: auto;
        ::v-deep {
          .el-tree-node__expand-icon {
            display: none !important;
          }
          .el-input-group__append {
            border-left: none;
            background: #fff;
            color: #4e5969;
            padding-left: 10px;
            padding-right: 10px;
            cursor: pointer;
            font-size: 15px;
          }
        }
      }
    }
    .bottom-content-right {
      .bottom-content-right-header {
        height: 40px;
        line-height: 40px;
        padding: 0 16px;
        background: #f7f8fa;
        display: flex;
        justify-content: space-between;
        align-items: center;
        span {
          color: #1d2129;
          font-family: PingFang SC;
          font-size: 14px;
          font-weight: 600;
        }
        .text {
          color: #86909c;
          font-size: 10px;
          font-weight: normal;
          display: inline-block;
          margin-left: 6px;
        }
        .count {
          color: #4e5969;
          font-size: 13px;
          font-weight: normal;
        }
      }
      .sortable-row .drag-btn {
        cursor: move;
        font-size: 12px;
      }
      .sortable-row .vxe-body--row.sortable-ghost,
      .sortable-row .vxe-body--row.sortable-chosen {
        background-color: #dfecfb;
      }
      ::v-deep {
        .el-input__inner{
          height: 24px !important;
        }
      }
    }
  }
}
</style>
<style type="scss">
.tooltip-icon {
  font-size: 12px;
  line-height: 18px;
  padding: 4px 8px !important;
}
</style>
<style type="scss">
.popper-export-view {
  padding: 0 !important;
  .view-list {
    width: 280px;
    .view-title {
      height: 40px;
      padding: 0 12px;
      border-bottom: 1px solid #eee;
      box-sizing: border-box;
      color: #1d2129;
      font-size: 14px;
      > span {
        font-weight: 600;
      }
    }
    .view-content {
      max-height: 186px;
      overflow: auto;
      padding: 3px;
      .view-item {
        height: 34px;
        padding: 0 12px;
        margin-top: 5px;
        font-size: 14px;
        &:first-child {
          margin-top: 0;
        }
        &:hover {
          background-color: #e8f2ff;
        }
      }
    }
  }
}
</style>
